export const ROUTERS = {
    login: 'login',
    home_user: 'part-user',
    register_user: "part-register-user",
    regulamento: "regulamento"
  };
  